// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Skills_componentWrapper__Hstiv","contentContainer":"Skills_contentContainer__qGA5S","skillsContainer":"Skills_skillsContainer__gqVfp"};